import { useHttp } from "../http/useHttp";
import { useAxiosMutation } from "../http/useAxiosMutation";
import { useAuth } from "../auth/useAuth";
import { paths } from "../generated-types";

type LogoutOperation = paths["/dashboard/logout"]["post"];
export type ILogoutInput = LogoutOperation["requestBody"]["content"]["application/json"];

export const useLogout = () => {
  const { refetch } = useAuth();
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMutation<void, ILogoutInput>({
    mutationKey: ["logout"],
    mutationFn: (input) => client.post("/logout", input),
    onSuccess: () => refetch(),
  });

  return { logout: mutate, isPending, status, data, error };
};
